export const MINIO_PROVIDER = 'minio';
export const AWS_PROVIDER = 'aws';
export const IBM_PROVIDER = 'ibm';
export const OTHER_PROVIDER = 'other';
export const MAX_OBJECT_GET_SIZE = Number.MAX_SAFE_INTEGER;
